import { isLiteral, isNamedNode } from 'is-graph-pointer';
import { sh } from '@tpluscode/rdf-ns-builders';
import NodeExpression from './NodeExpression.js';
export class ConstantTermExpression extends NodeExpression {
    get requiresFullContext() {
        return false;
    }
    get rootIsFocusNode() {
        return false;
    }
    constructor(term) {
        super();
        this.term = term;
    }
    static fromPointer(pointer) {
        if (!ConstantTermExpression.match(pointer)) {
            throw new Error('Constant term must be a named node or literal');
        }
        return new ConstantTermExpression(pointer.term);
    }
    static match(pointer) {
        if (isNamedNode(pointer)) {
            return !pointer.term.equals(sh.this);
        }
        return isLiteral(pointer);
    }
    _buildPatterns({ object }) {
        return {
            type: 'bind',
            expression: this.term,
            variable: object,
        };
    }
    buildInlineExpression() {
        return {
            inline: this.term,
        };
    }
}
